import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiGet, apiPatch } from '../lib/api';
import type { OnboardingState } from '@pf/shared';

const QUERY_KEY = ['onboarding'];

export function useOnboarding() {
  return useQuery<{ data: OnboardingState }>({
    queryKey: QUERY_KEY,
    queryFn: () => apiGet<{ data: OnboardingState }>('/users/me/onboarding'),
    staleTime: 1000 * 30,
  });
}

export function useUpdateOnboarding() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: { step?: number; completed?: boolean }) =>
      apiPatch<{ data: { step: number; completed_at: string | null } }>('/users/me/onboarding', body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEY });
    },
  });
}
